module.exports = __webpack_public_path__ + "img/first_page.cd68a33b.svg";